import React, { FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Wrapper,
  HeadlineWrapper,
  Headline,
  EditIconWrapper,
  EditIcon,
  AdditionalItemDivider,
  DataWrapper,
  DataRow,
  DataRowHeader,
  DataRowContent,
} from './AdditionalListContentUI';
import styled from 'styled-components';
import { ProductCategory } from '../../interfaces/Product';
import { formatDate } from '../../utils/DateUtils';

export interface AdditionalProductCategoryListContentProps {
  item: ProductCategory;
  updateHook: () => void;
  deleteHook: () => void;
}

const ActionLink = styled.button`

`;
export const AdditionalProductCategoryListContent: FC<AdditionalProductCategoryListContentProps> = (props) => {
  const { item, updateHook, deleteHook } = props;

  return (
    <Wrapper>
      <HeadlineWrapper>
        <Headline>Einstellungen für {item.name}</Headline>
        <EditIconWrapper>
          <ActionLink onClick={() => {
            if (deleteHook) {
              deleteHook();
            }
          }}>
            <EditIcon icon={'trash'} size={22}/>
          </ActionLink>
        </EditIconWrapper>
        <EditIconWrapper>
          <ActionLink onClick={() => {
            if (updateHook) {
              updateHook();
            }
          }}>
            <EditIcon icon={'edit'} size={22}/>
          </ActionLink>
        </EditIconWrapper>
      </HeadlineWrapper>

      <AdditionalItemDivider/>

      {
        item?.products?.length > 0 ? (
          <DataWrapper>
            {item.products.map((product, index) => (
              <Fragment key={index}>
                <DataRow>
                  <DataRowHeader>{product.name}</DataRowHeader>
                  <DataRowContent>
                    <EditIconWrapper>
                      <Link to={`/products/${product.id}`}>
                        <EditIcon icon={'edit'} size={20}/>
                      </Link>
                    </EditIconWrapper>
                  </DataRowContent>
                </DataRow>
                <AdditionalItemDivider/>
              </Fragment>
            ))}
          </DataWrapper>
        ) : <DataRow>Keine Produkte gefunden</DataRow>
      }
    </Wrapper>
  );
};
